import React, { ReactElement } from 'react';
import { KatLink } from '@amzn/katal-react';
import { useTranslation, constructQueryParams } from 'src/utils';
import { useRouter } from 'next/router';
import QuoteCard from 'src/components/RichTextEditor/quote/QuoteCard';
import { Quote } from 'src/types/DiscussionPost';
import { getThreadDetail, THREAD_LISTING } from 'src/constants/pages';
import { QuoteRef } from 'src/types/Quotes';

export type QuotesContainerProps = Quote & {
  // eslint-disable-next-line react/require-default-props
  quoteRef?: QuoteRef,
  quoteId: string,
  contentJSX: ReactElement
};
const QuotesContainer: React.FC<QuotesContainerProps> = (props) => {
  const { t } = useTranslation();
  const { basePath, query, pathname } = useRouter();
  const {
    postId, quoteRef, quoteId, contentJSX,
  } = props;
  const quotedPostHref = query && query.threadId && `${basePath}${constructQueryParams({ postId }, getThreadDetail(query.threadId as string))}`;
  const quotedPostLink = pathname !== THREAD_LISTING && quotedPostHref ? (
    <KatLink data-testid="quoted-post-link" className="text-[11px]" href={quotedPostHref} variant="link">
      {t('discussionCard_showPosts')}
    </KatLink>
  ) : undefined;
  return (
    <div
      ref={(element: HTMLDivElement) => {
        if (quoteRef?.nonSelectable) {
          // eslint-disable-next-line no-param-reassign
          quoteRef.nonSelectable[quoteId] = element;
        }
      }}
    >
      <QuoteCard {...props} contentJSX={contentJSX} actions={quotedPostLink} />
    </div>
  );
};

export default QuotesContainer;
